module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-HeavyItalic.6554e782.woff";